import { extractErrorMessages } from '@fukuri-admins/ui/common/Form/logics/extractErrorMessages';
import { useController, useFormContext } from 'react-hook-form';
import { PasswordTextField } from '..';

type PasswordTextFieldProps = React.ComponentProps<typeof PasswordTextField>;

type Props = {
  name: string;
  passwordInput?: PasswordTextFieldProps['passwordInput'];
  fieldWrapperProps: Omit<PasswordTextFieldProps['fieldWrapperProps'], 'htmlFor' | 'errorMessages'>;
};

export const PasswordTextFieldController: React.FC<Props> = ({
  name,
  fieldWrapperProps: { labelText, labelType },
  passwordInput,
}: Props): JSX.Element => {
  const { control } = useFormContext();

  const {
    field: { ref, ...restField },
    fieldState: { error },
  } = useController({ control, name });

  return (
    <PasswordTextField
      fieldWrapperProps={{
        htmlFor: name,
        labelText,
        labelType,
        errorMessages: extractErrorMessages(error),
      }}
      passwordInput={{ ...passwordInput, error: !!error }}
      {...restField}
    />
  );
};
